import { Button, ButtonVariant, Dialog, Size } from '@hourly-hds/components';
import { Alert } from '@hourly-hds/icons/colored';
import styles from './BankAccountDialog.module.css';

export const ReplaceBankAccountConfirmationDialog = ({
  isOpen,
  onConfirm,
  onClose,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) => {
  const handleOnConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <div className={styles.overlayWrapper}>
      <Dialog size={Size.Medium} onClose={onClose} open={isOpen} modal>
        <Dialog.Header>
          <div className={styles.header}>
            <Alert />
            Replace Bank Account
          </div>
        </Dialog.Header>
        <Dialog.Content>
          <div className={styles.content}>
            {
              "You're about to override the existing bank account. Are you sure you want to proceed?"
            }
          </div>
        </Dialog.Content>
        <Dialog.Footer>
          <Button label="Cancel" onClick={onClose} />
          <Button variant={ButtonVariant.Primary} label={'Confirm'} onClick={handleOnConfirm} />
        </Dialog.Footer>
      </Dialog>
    </div>
  );
};

export const BankAccountReplacementSuccessDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <div className={styles.overlayWrapper}>
      <Dialog size={Size.Medium} onClose={onClose} open={isOpen} modal>
        <Dialog.Header>
          <div className={styles.header}>
            <Alert />
            Replace Bank Account
          </div>
        </Dialog.Header>
        <Dialog.Content>
          <div className={styles.content}>The bank account has been successfully updated.</div>
        </Dialog.Content>
        <Dialog.Footer>
          <Button label="Dismiss" onClick={onClose} />
        </Dialog.Footer>
      </Dialog>
    </div>
  );
};
